import { render, staticRenderFns } from "./GreySection.vue?vue&type=template&id=5c7b86ac&scoped=true"
import script from "./GreySection.vue?vue&type=script&lang=js"
export * from "./GreySection.vue?vue&type=script&lang=js"
import style0 from "./GreySection.vue?vue&type=style&index=0&id=5c7b86ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7b86ac",
  null
  
)

export default component.exports